import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//axios
import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.common['apikey'] = process.env.VUE_APP_API_KEY
axios.defaults.headers.common['Authorization'] = `Bearer ${process.env.VUE_APP_API_KEY}`

// Bootstrap
/* import './assets/bootstrap.min.css' */
import './assets/admin.css'
//import './assets/timeline.css'
import 'bootstrap/dist/js/bootstrap.bundle.js'
//import "./assets/scripts.js";

// Bootstrap Vue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Sweetalert2
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
Vue.use(VueSweetalert2)

// Validate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// vue-loading-overlay
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(Loading, { color: '#0061f2', loader: 'dots' })

// GoodTable
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin)

// filter
import './filters'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
